import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { useTRPC } from '../lib/trpc'
import { Notice } from '../ui'
import './login.css'

/**
 * The demo door: `/demo`, and everybody who opens it becomes the same visitor.
 *
 * It signs in on arrival rather than showing a button, because the address IS
 * the invitation — somebody followed a link that said "see the demo", and a
 * screen asking them to confirm that is a step that answers nothing.
 *
 * The reload is deliberate rather than a routed navigation: signing in changes
 * who the whole app thinks you are, and every query already in flight was asked
 * as nobody. Starting the page again is the one way to be sure nothing is left
 * holding an answer from before the session existed — the same reason the magic
 * link lands with one.
 */
export function DemoDoor() {
  const trpc = useTRPC()
  const started = useRef(false)
  const enter = useMutation(
    trpc.auth.signInToDemo.mutationOptions({
      onSuccess: () => window.location.assign('/'),
    }),
  )

  // Once. StrictMode mounts twice in development, and a second door opens a
  // second session for the same visitor.
  useEffect(() => {
    if (started.current) return
    started.current = true
    enter.mutate()
  }, [enter.mutate])

  if (!enter.isError) return null
  return (
    <div className="login">
      <div className="login__card">
        <Notice tone="error">{enter.error.message}</Notice>
        <p className="login__lede">
          The demo is not available at the moment. Nothing is wrong with your
          link.
        </p>
      </div>
    </div>
  )
}
